export default {
  reports: 'Reports',
  createReport: 'Create Report',
  selectRiderOrDriver: 'Select Rider or Driver ',
  selectReportType: 'Select report type',
  selectCampus: 'Select Campus',
  noDataFound: 'No data found for the selected report.',
  selectModules: 'Select Module',
  noModulesFound: 'No modules found',
  threshold: 'Threshold',
  enterThreshold: 'Enter threshold',
  selectCampus: 'Select Campus',
};
